import { useCustomerApi } from '../../hooks/useCustomerApi';
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};
export const useGetAllCustomer = (queryParams: Params, options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>) => {

  const { getAllCustomer } = useCustomerApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCustomer', queryParams],
    queryFn: () => {
      return getAllCustomer(queryParams);
    },
    ...options,
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};

export const useDeleteCustomerById = () => {
  const queryClient = useQueryClient();
  const { deleteCustomerById } = useCustomerApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteCustomer'],
    mutationFn: (ids: string[]) => {
      return deleteCustomerById(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Customer deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getCustomer'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to delete Customer',
        'error'
      );
    },
  });
};

export const useBlockUnblockCustomerById = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { blockOrUnblockCustomerById } = useCustomerApi();

  return useMutation({
    mutationKey: ['blockUnblockCustomer'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      blockOrUnblockCustomerById({ id, status: data.status }),

    onSuccess: (_response, _variables) => {
      const status = _variables.data.status;
      const action = status === 'blocked' ? 'blocked' : 'unblocked';
      showMessage(`Customer ${action} successfully`, 'success');

      queryClient.invalidateQueries({
        queryKey: ['getCustomer'],
        exact: false,
      });
    },

    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update Customer status',
        'error'
      );
    },
  });
};

export const useEditCustomerByID = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editCustomerById } = useCustomerApi();

  return useMutation({
    mutationKey: ['editCustomer'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editCustomerById(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Customer Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['Customer'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update the Customer',
        'error'
      );
    },
  });
};
